import React from "react";
import { Link } from "react-router-dom";
import SVGIcons from "../../../assets/images/icons/svgIcons";
import "./terms.scss"
import { ScrollToTopOnMount } from "../../../Components/ScrollToTop/ScrollToTop";


const TermsAndConditions = () => {
    ScrollToTopOnMount();

    return (
        <div className="page-main-wrapper privacy-main-wrapper f-wrp">
            <div className="container">
                <div className="breadcrumb f-wrp">
                    <Link to={'/'}> Home &nbsp;&nbsp;<SVGIcons.RightChevronIcon /></Link>&nbsp;
                    <p>Terms & Conditions</p>
                </div>
                <div className="TC-policy-wrp f-wrp">
                    <h1 className="main-header">Terms & Conditions</h1>
                    <br />
                    <br />
                    <p>Effective Date: April 17, 2025</p>
                    <br />
                    <p>1. Introduction</p>
                    <br />
                    <p>By accessing and using the website of Propshop Real Estate LLC <a style={{ color: 'inherit' }} href="https://propshop.ai">(https://propshop.ai)</a>, you agree to comply with and be bound by the terms and conditions outlined below. These terms govern your use of the website and any services or materials provided through it. </p>
                    <br />
                    <p>2. Governing Law</p>
                    <br />
                    <p>These terms shall be governed by and interpreted in accordance with the laws of the United Arab Emirates. Any disputes arising in relation to these terms shall fall under the exclusive jurisdiction of the UAE courts.</p>
                    <br />
                    <p>3. Intellectual Property</p>
                    <br />
                    <p>All content, graphics, branding, and layout displayed on this website, including but not limited to the Propshop Real Estate logo, are protected under applicable copyright and intellectual property laws.<br />
                        You may download or print materials for personal, non-commercial use only. Any reproduction, modification, distribution, or commercial exploitation of website content is strictly prohibited unless explicitly authorized in writing.
                    </p>
                    <br />
                    <p>Images not produced by Propshop may be licensed from third-party providers under appropriate usage terms.</p>
                    <br />
                    <p>4. Accuracy of Information</p>
                    <br />
                    <p>We strive to ensure that all information on our website is accurate and current. However, we do not guarantee the completeness, reliability, or timeliness of any content, and we reserve the right to make updates or changes at any time without prior notice.</p>
                    <br />
                    <p>5. Professional Advice Disclaimer</p>
                    <br />
                    <p>Propshop Real Estate offers professional real estate advisory and legal assistance related to property transactions. However, the information presented on this website should not be interpreted as a substitute for personalized legal, investment, or financial planning advice. Users are encouraged to consult licensed professionals before making decisions.</p>
                    <br />
                    <p>6. Limitation of Liability</p>
                    <br />
                    <p>Propshop Real Estate LLC shall not be held liable for any direct, indirect, incidental, or consequential loss or damages arising from:</p>
                    <br />
                    <ul>
                        <li>Use or inability to use this website;</li>
                        <li>Errors or omissions in the content;</li>
                        <li>Technical failures or malware affecting your system;</li>
                        <li>Decisions made based on information found on the site.</li>
                    </ul>
                    <br />
                    <p>Use of this website is at your own risk.</p>
                    <br />
                    <p>7. External Links</p>
                    <br />
                    <p>This website may include links to third-party websites for reference or convenience. Propshop Real Estate is not responsible for the content, policies, or practices of any external sites. You are advised to review their terms before interacting with those platforms.</p>
                    <br />
                    <p>8. Compliance and Regulatory Commitment</p>
                    <br />
                    <p>Anti-Money Laundering (AML) & Counter-Terrorism Financing (CFT)</p>
                    <br />
                    <p>As a registered entity in the UAE, Propshop Real Estate LLC complies with all regulations related to AML and CFT. We maintain a strong internal framework to identify and mitigate financial crime risks through:</p>
                    <br />
                    <ul>
                        <li>Know Your Customer (KYC) protocols</li>
                        <li>Risk-based client assessments</li>
                        <li>Transaction monitoring</li>
                        <li>Timely reporting of suspicious activity in line with UAE legislation</li>
                    </ul>
                    <br />
                    <p>Sanctions Compliance</p>
                    <br />
                    <p>We adhere to international and UAE-imposed sanctions, avoiding any transactions that may involve restricted individuals, entities, or countries.</p>
                    <br />
                    <p>Corporate Governance</p>
                    <br />
                    <p>We uphold the standards of Designated Non-Financial Businesses and Professions (DNFBP) and operate with a commitment to transparency, fairness, and ethical business practices.</p>
                    <br />
                    <p>9. User Responsibilities</p>
                    <br />
                    <p>You agree not to misuse this website, interfere with its operation, or provide false information through any forms or communications.</p>
                    <br />
                    <p>10. Modifications</p>
                    <br />
                    <p>Propshop Real Estate LLC may revise these Terms & Conditions from time to time. Continued use of the website constitutes your acceptance of any updates. We encourage users to review this page periodically.</p>
                    <br />
                    <h4>Company Information:</h4>
                    <br />
                    <p style={{ lineHeight: '1.6' }}>
                        Propshop Real Estate LLC<br />
                        Trade License No. 1157344<br />
                        Office Address: Building 3b, Street 69a, Jumeirah 1, Dubai, UAE<br />
                        Landline: <a style={{ color: 'inherit' }} href="tel:+971568816886">+971 56 881 6886</a><br />
                        Mobile: <a style={{ color: 'inherit' }} href="tel:+971568816886">+971 56 881 6886</a><br />
                        Email: <a style={{ color: 'inherit' }} href="mailto:admin@propshop.ai">admin@propshop.ai</a><br />
                        Website: <a style={{ color: 'inherit', textDecoration: 'underline !important' }} href="https://propshop.ai">https://propshop.ai</a><br />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
